import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recipt-from-rivhit',
  templateUrl: './recipt-from-rivhit.component.html',
  styleUrls: ['./recipt-from-rivhit.component.css']
})
export class ReciptFromRivhitComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
